const FOOTER = `<div class="hal-footer">
<div class="hal-container hal-container--plain hal-container-terms">
<div class="hal-container-content">
<div class="hal-columns">
<div class="hal-column">
<div class="hal-column-content"><ul class="hal-footer-list hal-footer-list--terms hal-list hal-list--plain">
<li>
<span class="hal-rtl--alt">Terms and Conditions:</span>
</li>
<li>
<a href="https://www.hapag-lloyd.com/en/meta/legal-terms.html" class="hal-rtl--alt">Terms of Use Website</a>
</li>
<li>
<a href="https://www.hapag-lloyd.com/en/meta/terms-conditions-transport.html" class="hal-rtl--alt">Terms of Transport</a>
</li>
<li>
<a href="https://www.hapag-lloyd.com/en/meta/terms-conditions-purchase.html" class="hal-rtl--alt">Terms of Purchase</a>
</li>
<li>
<a href="https://www.hapag-lloyd.com/en/meta/imprint.html" class="hal-rtl--alt">Imprint</a>
</li>
<li>
<a href="https://www.hapag-lloyd.com/en/meta/privacy-statement.html" class="hal-rtl--alt">Privacy Terms</a>
</li>
<li>
<a href="https://www.hapag-lloyd.com/en/meta/cookie-policy.html" class="hal-rtl--alt">Cookie Policy</a>
</li>
</ul>
</div>
</div>
<div class="hal-column  hal-column--margin">
<div class="hal-column-content">
<p class="hal-copyright hal-rtl--alt">© Hapag-Lloyd AG</p>
</div>
</div>
</div>
</div>
</div>
</div>`;

export default FOOTER;
